export const boardRoutesNames = {
  BOARD_VIEW: 'e',
  BOARD_LIST: 'dashboard',
  BOARD_PREVIEW: 'preview',
  BOARD_EMBED: 'embed',
  BOARD_TEST: 'test'
};
